import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import PublisherLogo from '../publisherLogo';
import StatusPill from '../statusPill';
import ScheduleEntry from './scheduleEntry';
import ScheduleList from './scheduleList';
import * as styles from './styles';

function SubscriptionCard({
    subscriptionId,
    publisher = {},
    app = {},
    timezone,
    lastSyncedLabel,
    isActive,
    connectedSchedules = [],
    availableSchedules = [],
    onUnsubscribe,
    onRemoveSchedule,
    onAddSchedule,
}) {
    function renderList(schedules, actionLabel, onAction, listType) {
        return (
            <ScheduleList>
                {schedules.map((s, index) => (
                    <ScheduleEntry
                        key={`${subscriptionId}-${listType}-${index}`}
                        schedule={s}
                        actionLabel={actionLabel}
                        onAction={(scheduleId) => onAction(subscriptionId, scheduleId)}
                    />
                ))}
            </ScheduleList>
        );
    }

    const renderConnectedSchedulesList = () => renderList(connectedSchedules, 'Remove', onRemoveSchedule, 'connected-sched');
    const renderAvailableSchedulesList = () => renderList(availableSchedules, 'Add', onAddSchedule, 'more-sched');

    function renderApp() {
        if (!app.application) return null;
        return <Box sx={styles.metaPill}>{app.application}</Box>;
    }

    function renderDevice() {
        if (!app.device) return null;
        return <Box sx={styles.metaPill}>{app.device}</Box>;
    }

    function renderTimezone() {
        if (!timezone) return null;
        return <Box sx={styles.metaPill}>{timezone}</Box>;
    }

    function renderLastSynced() {
        if (!lastSyncedLabel) return null;
        return (
            <Typography sx={styles.metaText}>
                Last sync {lastSyncedLabel}
            </Typography>
        );
    }

    function renderHeader() {
        return (
            <Box sx={styles.header}>
                <PublisherLogo
                    logo={publisher.logo}
                    name={publisher.name}
                    size={48}
                />

                <Box sx={styles.publisherInfo}>
                    <Typography sx={styles.publisherName}>{publisher.name}</Typography>
                    <Box sx={styles.metaRow}>
                        <StatusPill isActive={isActive} />
                        {renderApp()}
                        {renderDevice()}
                        {renderTimezone()}
                        {renderLastSynced()}
                    </Box>
                </Box>

                {onUnsubscribe && (
                    <Box sx={styles.unsubscribeWrapper}>
                        <Button onClick={onUnsubscribe} sx={styles.unsubscribeButton}>
                            Unsubscribe
                        </Button>
                    </Box>
                )}
            </Box>
        );
    }

    function renderConnectedSchedules() {
        return (
            <Box>
                <Typography sx={styles.schedulesLabel}>Connected schedules</Typography>
                {connectedSchedules.length === 0
                    ? <Typography sx={styles.emptySchedules}>No active schedules.</Typography>
                    : renderConnectedSchedulesList()
                }
            </Box>
        );
    }

    function renderAvailableSchedules() {
        return (
            <Box>
                <Typography sx={styles.schedulesLabel}>Add more schedules</Typography>
                {availableSchedules.length === 0
                    ? <Typography sx={styles.emptySchedules}>No more schedules available.</Typography>
                    : renderAvailableSchedulesList()
                }
            </Box>
        );
    }

    return (
        <Box component="article" sx={styles.card}>
            {renderHeader()}
            <Box sx={styles.schedulesGrid}>
                {renderConnectedSchedules()}
                {renderAvailableSchedules()}
            </Box>
        </Box>
    );
}

export default SubscriptionCard;
